// extracted by mini-css-extract-plugin
module.exports = {"componentStyle":"page_componentStyle__4Cgfr","campaignKvContainer":"page_campaignKvContainer__aS6TV","campaignKv":"page_campaignKv__JsuFZ"};